import { c as _c } from "react/compiler-runtime";
import { Image } from '@/components/client';
interface PhotoReviewItemProps {
  onClick: () => void;
  src: string;
  alt: string;
}
export const PhotoReviewItem = t0 => {
  const $ = _c(6);
  const {
    onClick,
    src,
    alt
  } = t0;
  let t1;
  if ($[0] !== alt || $[1] !== src) {
    t1 = <Image width={112} height={112} src={src} alt={alt} className="object-cover" />;
    $[0] = alt;
    $[1] = src;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onClick || $[4] !== t1) {
    t2 = <button type="button" onClick={onClick} className="aspect-square overflow-hidden rounded-small border border-Gray-black/5">{t1}</button>;
    $[3] = onClick;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};